import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration
const whiteList = ['/login', '/auth-redirect'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
  NProgress.start()
  if (to.path === '/' || to.path === '/home/matchInfo' || to.path === '/home/matchCore' || to.path === '/home/homePage' || to.path === '/matchCore') {
    next()
    NProgress.done()
    return
  }
  document.title =
    to.meta.title && typeof to.meta.title !== 'string'
      ? getPageTitle(to.meta.title[to.params.type])
      : getPageTitle(to.meta.title)
  // const hasToken = getToken()
  const hasToken = getToken() || store.getters.token
  const userId = store.getters.userId
  if (hasToken) {
    if (to.path === '/login') {
      next()
    } else {
      if (userId) {
        next()
        NProgress.done()
      } else {
        store.dispatch('user/getAuthUserInfo')
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next({ path: `/login?redirect=${to.path}`, query: to.query })
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
